/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  LogProbToken,
  LogProbToken$inboundSchema,
  LogProbToken$Outbound,
  LogProbToken$outboundSchema,
} from "./logprobtoken.js";

export type ResponseOutputTextDeltaEvent = {
  type: "response.output_text.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  contentIndex: number;
  delta: string;
  logprobs?: Array<LogProbToken> | undefined;
};

/** @internal */
export const ResponseOutputTextDeltaEvent$inboundSchema: z.ZodType<
  ResponseOutputTextDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.output_text.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  content_index: z.number().int(),
  delta: z.string(),
  logprobs: z.array(LogProbToken$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "content_index": "contentIndex",
  });
});
/** @internal */
export type ResponseOutputTextDeltaEvent$Outbound = {
  type: "response.output_text.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  content_index: number;
  delta: string;
  logprobs?: Array<LogProbToken$Outbound> | undefined;
};

/** @internal */
export const ResponseOutputTextDeltaEvent$outboundSchema: z.ZodType<
  ResponseOutputTextDeltaEvent$Outbound,
  z.ZodTypeDef,
  ResponseOutputTextDeltaEvent
> = z.object({
  type: z.literal("response.output_text.delta"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  contentIndex: z.number().int(),
  delta: z.string(),
  logprobs: z.array(LogProbToken$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    contentIndex: "content_index",
  });
});

export function responseOutputTextDeltaEventToJSON(
  responseOutputTextDeltaEvent: ResponseOutputTextDeltaEvent,
): string {
  return JSON.stringify(
    ResponseOutputTextDeltaEvent$outboundSchema.parse(
      responseOutputTextDeltaEvent,
    ),
  );
}
export function responseOutputTextDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseOutputTextDeltaEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseOutputTextDeltaEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseOutputTextDeltaEvent' from JSON`,
  );
}
